// TEMPORARY on-device diagnostics. Records a small ring buffer of breadcrumbs in
// localStorage so we can see what happens on a real device (no console access in
// Telegram iOS) — e.g. whether the app reloads/crashes or a sheet closes, and
// why. Surfaced in Profile → "Diagnostics". Remove once the bug is found.

const KEY = 'incpt_dbg_v1';
const MAX = 60;

export type DbgEntry = { t: number; m: string };

export function dbg(m: string): void {
  try {
    const arr = JSON.parse(localStorage.getItem(KEY) || '[]') as DbgEntry[];
    arr.push({ t: Date.now(), m });
    while (arr.length > MAX) arr.shift();
    localStorage.setItem(KEY, JSON.stringify(arr));
  } catch {
    /* storage unavailable — ignore */
  }
}

export function dbgRead(): DbgEntry[] {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '[]') as DbgEntry[];
  } catch {
    return [];
  }
}

export function dbgClear(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

// ---------------------------------------------------------------------------
// TEMPORARY on-device bisection flags (non-visual). Toggled from Profile →
// Diagnostics; persisted in localStorage; read at boot.
// ---------------------------------------------------------------------------
const FLAG_KEY = 'incpt_dbg_flags_v1';

export type DbgFlag = 'nolottie' | 'novv' | 'noglass' | 'noimg';

export const DBG_FLAGS: { id: DbgFlag; label: string }[] = [
  { id: 'nolottie', label: 'lottie anims' },
  { id: 'novv', label: 'viewport handler' },
  { id: 'noglass', label: 'liquid glass' },
  { id: 'noimg', label: 'card images' },
];

export function dbgFlags(): Record<string, boolean> {
  try {
    return JSON.parse(localStorage.getItem(FLAG_KEY) || '{}') as Record<string, boolean>;
  } catch {
    return {};
  }
}

export function dbgFlag(name: DbgFlag): boolean {
  return dbgFlags()[name] === true;
}

export function dbgSetFlag(name: DbgFlag, on: boolean): void {
  try {
    const f = dbgFlags();
    f[name] = on;
    localStorage.setItem(FLAG_KEY, JSON.stringify(f));
  } catch {
    /* ignore */
  }
}

/** Human-readable list of active flags, for the BOOT breadcrumb. */
export function dbgActiveFlags(): string {
  const f = dbgFlags();
  const on = Object.keys(f).filter((k) => f[k]);
  return on.length ? on.join(',') : 'none';
}
